import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Drawer from "components/ui/drawer/Drawer";
import { AiQuickPromptChatType } from "lib/types/graphQLEnums";
import QuickPromptsEditor from "./QuickPromptsEditor";

const DRAWER_WIDTH = 480;

type Props = {
  chatType: AiQuickPromptChatType;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

// Edits the team's quick prompts over the page, so an AI chat and anything typed into it stay put
export default function QuickPromptsDrawer({ chatType, open, onOpenChange }: Props): JSX.Element {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} padding={24} width={DRAWER_WIDTH}>
      <QuickPromptsEditor
        chatType={chatType}
        gap={24}
        renderHeader={(actions) => (
          <Flex column gap={16}>
            <Flex justifyContent="space-between" alignItems="center">
              <Text h2>Quick prompts</Text>
              <Button
                icon="xClose"
                buttonType="tertiary"
                aria-label="Close quick prompts"
                onClick={() => onOpenChange(false)}
              />
            </Flex>
            <Text>
              Choosing a quick prompt puts it in the input, ready to edit and send. Changes apply to
              everyone in your team.
            </Text>
            <Flex gap={8} alignItems="center" justifyContent="flex-end">
              {actions}
            </Flex>
          </Flex>
        )}
      />
    </Drawer>
  );
}
